import { PartnerAccount } from '@tmx/data-access';
import { map, pipe } from 'rxjs';

import { DropdownOption } from '../../../models/dropdown-option';

export function toDropdownOptions() {
  return pipe(
    map<
      { customerAccounts: PartnerAccount[]; partnerAccounts: PartnerAccount[] },
      { customerAccounts: DropdownOption[]; partnerAccounts: DropdownOption[] }
    >(({ partnerAccounts, customerAccounts }) => {
      return {
        partnerAccounts: partnerAccounts.map(
          (account) => new DropdownOption(account.name, account.alias)
        ),
        customerAccounts: customerAccounts.map(
          (account) => new DropdownOption(account.name, account.alias)
        ),
      };
    })
  );
}
